module.exports = __webpack_public_path__ + "static/media/vintage11.a091957b.png";